export const ROUTES_NAMESPACE = 'routes';

/**
 * List of vuex module getters
 */
export const PAGE_GETTER = 'getPageById';
export const PAGE_BY_NAME_GETTER = 'getPageByName';
export const PAGES_GETTER = 'getPages';

/**
 * List of vuex module mutations
 */
export const ADD_FORM_MUTATION = 'addFormMutation';

/**
 * List of vuex module actions
 */
export const VALIDATE_PAGE_FORMS_ACTION = 'validatePageForms';

/**
 * List of pages constants
 */
export const PAGE_FLIGHTS_NAME = 'flights';
export const PAGE_FLIGHTS_TITLE = 'Flights';
export const PAGE_FLIGHTS_ROUTE = '/';
export const PAGE_FLIGHTS_ID = 1;
export const PAGE_TRAVELLERS_NAME = 'travellers';
export const PAGE_TRAVELLERS_TITLE = 'Travellers';
export const PAGE_TRAVELLERS_ROUTE = 'travellers';
export const PAGE_TRAVELLERS_ID = 2;
export const PAGE_PURCHASE_NAME = 'purchase';
export const PAGE_PURCHASE_TITLE = 'Purchase';
export const PAGE_PURCHASE_ROUTE = 'purchase';
export const PAGE_PURCHASE_ID = 3;

export default {
    namespaced: true,
    state: {
        pages: [
            {
                id: PAGE_FLIGHTS_ID,
                name: PAGE_FLIGHTS_NAME,
                title: PAGE_FLIGHTS_TITLE,
                forms: []
            },
            {
                id: PAGE_TRAVELLERS_ID,
                name: PAGE_TRAVELLERS_NAME,
                title: PAGE_TRAVELLERS_TITLE,
                forms: []
            },
            {
                id: PAGE_PURCHASE_ID,
                name: PAGE_PURCHASE_NAME,
                title: PAGE_PURCHASE_TITLE,
                forms: []
            }
        ]
    },
    getters: {
        /**
         * Return state of requested page by id
         *
         * @param {Object} state - Vuex state
         *
         * @return {Object}
         */
        [PAGE_GETTER]: state => pageId => state.pages.find(page => page.id === pageId),
        /**
         * Return state of requested page by name
         *
         * @param {Object} state - Vuex state
         *
         * @return {Object}
         */
        [PAGE_BY_NAME_GETTER]: state => pageName => state.pages.find(page => page.name === pageName),
        /**
         * Return state of all pages
         *
         * @param {Object} state - Vuex state
         *
         * @return {Array}
         */
        [PAGES_GETTER]: state => state.pages
    },
    actions: {
        /**
         * Validate page forms
         *
         * @param {Object} context - Vuex actions context
         * @param {string} pageName
         *
         * @return {bool}
         */
        async [VALIDATE_PAGE_FORMS_ACTION](context, pageName) {
            const page = context.state.pages.find(route => route.name === pageName);
            if (page.forms.length) {
                const result = await Promise.all(page.forms.map(async form => {
                    try {
                        return await form.validate();
                    } catch {
                        return false;
                    }
                }));
                return result.every(form => form);
            }
            return true;
        }
    },
    mutations: {
        /**
         * Save state of requested page forms
         *
         * @param {Object} state - Vuex state
         * @param {Object} formData
         *
         * @return {void}
         */
        [ADD_FORM_MUTATION](state, {pageId, form}) {
            const page = state.pages.find(page => page.id === pageId);
            page.forms.push(form);
        }
    }
};
